import { getFeatureFlag } from '@/global/plugins/firebase'
import { PrefetchFeatureFlags } from './types'
import { makeFeatureFlagKey } from '../react-query-keys'

const prefetchFeatureFlags = async ({
  queryClient,
  featureFlagConstants
}: PrefetchFeatureFlags) => {
  await Promise.allSettled(
    featureFlagConstants.map(featureFlagConstant =>
      queryClient.prefetchQuery({
        queryKey: makeFeatureFlagKey({
          namespace: featureFlagConstant.namespace,
          key: featureFlagConstant.key
        }),
        queryFn: () =>
          getFeatureFlag({
            namespace: featureFlagConstant.namespace,
            key: featureFlagConstant.key
          })
      })
    )
  )
}

export { prefetchFeatureFlags }
